// extracted by mini-css-extract-plugin
export default {"marketplaceRouter":"_1nrmoh4","marketplaceRouterEditor":"_19zmrjp","marketplaceRouterSa":"_17lf2s6"};